import axios from 'axios';
import { tokenStorage } from '../utils/tokenStorage';

const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${tokenStorage.getAccessToken()}`
  }
});

export const candidateService = {
  // Get all candidates (Admin, HR only)
  getAllCandidates: async (page = 1, limit = 20, filters = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (filters.name) params.set('name', filters.name);
    if (filters.passportNumber) params.set('passportNumber', filters.passportNumber);
    if (filters.jobRole) params.set('jobRole', filters.jobRole);
    if (filters.mobile) params.set('mobile', filters.mobile);
    const response = await axios.get(
      `${API_URL}/candidates?${params.toString()}`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Search candidates
  searchCandidates: async (filters) => {
    const params = new URLSearchParams();
    if (filters.name) params.append('name', filters.name);
    if (filters.passportNumber) params.append('passportNumber', filters.passportNumber);
    if (filters.jobRole) params.append('jobRole', filters.jobRole);
    if (filters.nationality) params.append('nationality', filters.nationality);

    const response = await axios.get(
      `${API_URL}/candidates/search?${params.toString()}`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get candidate by ID
  getCandidateById: async (id) => {
    const response = await axios.get(
      `${API_URL}/candidates/${id}`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Create new candidate
  createCandidate: async (candidateData) => {
    const response = await axios.post(
      `${API_URL}/candidates`,
      candidateData,
      getAuthHeaders()
    );
    return response.data;
  },

  // Update candidate profile
  updateCandidate: async (id, updateData) => {
    const response = await axios.patch(
      `${API_URL}/candidates/${id}`,
      updateData,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get candidate's applications
  getCandidateApplications: async (id) => {
    const response = await axios.get(
      `${API_URL}/candidates/${id}/applications`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get candidate's documents
  getCandidateDocuments: async (id) => {
    const response = await axios.get(
      `${API_URL}/candidates/${id}/documents`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get candidate by user ID
  getCandidateByUserId: async (userId) => {
    const response = await axios.get(
      `${API_URL}/candidates/user/${userId}`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get admin candidate details with applications (Admin only)
  getAdminCandidateDetails: async (id) => {
    const response = await axios.get(
      `${API_URL}/candidates/${id}/admin-details`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Upload profile photo
  uploadProfilePhoto: async (file) => {
    const formData = new FormData();
    formData.append('photo', file);

    const response = await axios.post(
      `${API_URL}/candidates/profile/photo`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${tokenStorage.getAccessToken()}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  }
};

export default candidateService;
